import React, { useState } from "react";
import { InputType } from "zlib";
import { EyeIcon, EyeOffIcon } from "components/Common/Icons";

interface IInputFieldProps {
  onChange: (e: any) => void;
  value: any;
  label?: string;
  extras?: any;
  id?: string;
  type?: InputType;
  placeholder?: string;
  customClass?: string;
  containerClass?: string;
  error?: any;
  showPasswordToggle?: boolean;
}

const InputField: React.FC<IInputFieldProps> = ({
  extras,
  onChange,
  value,
  label,
  type = "text",
  placeholder = "",
  customClass = "",
  containerClass = "",
  error,
  showPasswordToggle = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordField = type === "password";
  const inputType = isPasswordField && showPassword ? "text" : type;

  // Parse label to separate text and asterisk
  const getLabelParts = () => {
    if (!label) return { text: "", hasAsterisk: false };
    const hasAsterisk = label.includes("*");
    const text = label.replace(/\s*\*\s*$/, "").trim();
    return { text, hasAsterisk };
  };

  const { text: labelText, hasAsterisk } = getLabelParts();

  return (
    <div className={`mb-2 ${containerClass}`}>
      {label && (
        <label
          htmlFor="large-input"
          className="block mb-2 font-poppins text-xs font-semibold md:font-normal leading-[12px] text-darkBlack"
        >
          {labelText}
          {hasAsterisk && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          type={inputType}
          id="large-input"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...extras}
          className={`block w-full px-3 py-2.5 text-gray-900 border rounded-md focus:ring-primary focus:border-primary font-poppins text-base md:text-sm leading-normal ${
            showPasswordToggle && isPasswordField ? "pr-10" : ""
          } ${customClass} ${!error ? `border-black20` : `border-red-400`}`}
        />
        {showPasswordToggle && isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <EyeIcon /> : <EyeOffIcon />}
          </button>
        )}
      </div>
      {error && <div className="pt-1 pl-1 text-sm text-red-600"> {error}</div>}
    </div>
  );
};

export default InputField;
